// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'f339b67f-6095-406e-9cf5-a94635a8648b',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '09dcd595-e538-4903-b93a-5173708e8088',
      type: 'Container',
      name: 'smokeContainer',
      className: '',
      x: 0,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f339b67f-6095-406e-9cf5-a94635a8648b'
    },
    {
      id: '3ea9ffa6-dea2-4908-9524-e171bae05985',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Red_Wheels',
      parent: 'f339b67f-6095-406e-9cf5-a94635a8648b'
    },
    {
      id: 'eb657b69-7510-4a41-a69e-9dddc140cb87',
      type: 'Sprite',
      name: 'car',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Blue',
      parent: 'f339b67f-6095-406e-9cf5-a94635a8648b',
      stateByName: {
        player: {
          texture: 'Race_Event_Small_Car_Red'
        }
      }
    },
    {
      id: 'a6c4d25b-99af-4ea8-93a0-5cc5e60c57b4',
      type: 'Container',
      name: 'tireWhooshesWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f339b67f-6095-406e-9cf5-a94635a8648b'
    },
    {
      id: 'c74e759f-fefc-4bb3-8608-db6705ad71ab',
      type: 'Container',
      name: 'tireWhooshes',
      className: '',
      x: 0,
      y: -47,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a6c4d25b-99af-4ea8-93a0-5cc5e60c57b4'
    },
    {
      id: '0035fed5-0468-41c0-9161-7e899f24232f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -38,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Wheel_Speed_Effect',
      parent: 'c74e759f-fefc-4bb3-8608-db6705ad71ab'
    },
    {
      id: '4aa12a5d-2726-4c5c-836e-3774f9dcbe5d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -38,
      y: 75,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Wheel_Speed_Effect',
      parent: 'c74e759f-fefc-4bb3-8608-db6705ad71ab'
    },
    {
      id: '0e8fd114-2e73-4f02-9b0e-6ceb14b7a4b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 38,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Wheel_Speed_Effect',
      parent: 'c74e759f-fefc-4bb3-8608-db6705ad71ab'
    },
    {
      id: '2278dbb7-1a52-4861-b080-a69c295e9094',
      type: 'Sprite',
      name: '',
      className: '',
      x: 38,
      y: 75,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Small_Car_Wheel_Speed_Effect',
      parent: 'c74e759f-fefc-4bb3-8608-db6705ad71ab'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'player'
  ],
  animations: [
    {
      id: '2900e70b-3535-4a19-a04e-1864d44c296a',
      name: 'Wheel_Driving',
      playingSpeed: 1,
      totalDuration: 200,
      blocks: [
        {
          id: '7e76c50e-a2ef-4b4b-a03a-35f3188c9515',
          type: 'Setter',
          name: 'tire_Setter',
          track: 1,
          target: {
            y: -55,
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tireWhooshes',
          disabled: false
        },
        {
          id: '6711a421-4b39-4b94-a5de-ad4b53c7e65b',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 100,
          track: 4,
          target: {
            alpha: 0.5
          },
          startAt: 0,
          sourceName: 'tireWhooshes',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '079ab814-69f4-4076-ad2f-b73f195676df',
          type: 'Tween',
          name: 'New_tween',
          duration: 200,
          track: 2,
          target: {
            y: -19
          },
          startAt: 0,
          sourceName: 'tireWhooshes',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '1af24d5e-9ce8-47fa-b623-7269cc6c0951',
          type: 'Tween',
          name: 'New_tween_1_copy',
          duration: 100,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'tireWhooshes',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'ec658b03-cd1d-49ca-89aa-68b02692bea9',
      name: 'Car_Bounce',
      playingSpeed: 1,
      totalDuration: 1500,
      blocks: [
        {
          id: 'c948884b-c4b7-4d8d-ac18-37a35a7d6ab1',
          type: 'Tween',
          name: 'pivot',
          duration: 700,
          track: 1,
          target: {
            pivot: {
              y: 7
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'CubicInOut',
          disabled: false
        },
        {
          id: '23bcc766-f7b0-45a4-8468-41f08d43545d',
          type: 'Tween',
          name: 'pivot2',
          duration: 800,
          track: 1,
          target: {
            pivot: {
              y: 0
            }
          },
          startAt: 700,
          sourceName: 'root',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: '1a4420b1-b0d1-464e-ae9e-9a0fd4a105f6',
      name: 'Car_Scale',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: 'dce0f1d9-b69d-49e3-ae2e-f5b50e550e63',
          type: 'Tween',
          name: 'New_tween_2_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.03,
              y: 1.03
            }
          },
          startAt: 0,
          sourceName: 'car',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '1fdef54c-0990-4b23-b035-bb1dcb5503ea',
          type: 'Tween',
          name: 'New_tween_2_1_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 250,
          sourceName: 'car',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: '0d22bb2f-2372-4d69-985d-66d771d3565d',
      name: 'Smoke',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'ca3a21a1-e059-462f-9e5b-3a173276b43b',
          type: 'Setter',
          name: 'FXPART_Race_Event_Smoke_Particles_Race_Track',
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'smokeContainer',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventCarLayout {
  static raw = raw;
  root!: Container;
  smokeContainer!: Container;
  car!: Sprite;
  tireWhooshesWrapper!: Container;
  tireWhooshes!: Container;
  StateName!: 'player';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Wheel_Driving {
  Layout: {
    tireWhooshes: object;
  };

  BlockTypeByName: {
    tire_Setter: object;
    New_tween_1: object;
    New_tween: object;
    New_tween_1_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Car_Bounce {
  Layout: {
    root: object;
  };

  BlockTypeByName: {
    pivot: object;
    pivot2: object;
  };

  flowData = raw.animations[1];
}

export abstract class Car_Scale {
  Layout: {
    car: object;
  };

  BlockTypeByName: {
    New_tween_2_1: object;
    New_tween_2_1_copy: object;
  };

  flowData = raw.animations[2];
}

export abstract class Smoke {
  Layout: {
    smokeContainer: object;
  };

  BlockTypeByName: {
    FXPART_Race_Event_Smoke_Particles_Race_Track: object;
  };

  flowData = raw.animations[3];
}
